var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto mb-15",nativeOn:{"click":function($event){return _vm.goTo(_vm.post.buttonLink)}}},[_c('v-img',{attrs:{"src":_vm.post.imageUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }